import { useRef } from 'react';

import { CircleButton } from '@/lib/shared/components/Buttons';
import { P2, H1 } from '@/lib/shared/components/Typography';
import { ListPointStarIcon, ArrowIcon } from '@/lib/shared/icons';

import { clsx } from 'clsx';
import { useTranslation } from 'next-i18next';

import styles from './CompanyHistory.module.scss';

type YearItemProps = {
  yearText: string;
  year: string;
};

const years = [
  {
    yearText: '2012History',
    year: '2012',
  },
  {
    yearText: '2014History',
    year: '2014',
  },
  {
    yearText: '2015History',
    year: '2015',
  },
  {
    yearText: '2016History',
    year: '2016',
  },
  {
    yearText: '2018History',
    year: '2018',
  },
  {
    yearText: '2019History',
    year: '2019',
  },
  {
    yearText: '2020History',
    year: '2020',
  },
  {
    yearText: '2021History',
    year: '2021',
  },
  {
    yearText: '2022History',
    year: '2022',
  },
  {
    yearText: '2023History',
    year: '2023',
  },
  {
    yearText: '2026History',
    year: '2026',
  },
];

const YearItem = ({ year, yearText }: YearItemProps) => {
  return (
    <div className={styles.history__year}>
      <div className={styles.history__number}>{year}</div>
      <ListPointStarIcon className={styles.history__listItem_icon} />
      <div className={styles.history__yearLine} />
      <P2 className={styles.history__yearText}>{yearText}</P2>
      {year === '2026' && (
        <ListPointStarIcon
          className={clsx(
            styles.history__listItem_icon,
            styles.history__lastImage
          )}
        />
      )}
    </div>
  );
};

export const CompanyHistory = () => {
  const { t } = useTranslation('index', { keyPrefix: 'about' });
  const yearsRef = useRef<HTMLDivElement>(null);
  const scrollYear = (direction: 'left' | 'right') => {
    if (!yearsRef.current) return;
    const currentScrollPos = yearsRef.current.scrollLeft;
    const scrollStep = 250;
    if (direction === 'right') {
      yearsRef.current.scrollTo({
        left: currentScrollPos + scrollStep,
        behavior: 'smooth',
      });
    } else {
      yearsRef.current.scrollTo({
        left: currentScrollPos - scrollStep,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className={styles.history}>
      <div className={clsx(styles.container, styles.history__wrapper)}>
        <H1 as={'h2'} className={styles.history__title}>
          {t('companyHistory')}
        </H1>
        <div className={styles.history__yearsWrapper} ref={yearsRef}>
          {years.map((year) => (
            <YearItem
              year={year.year}
              key={year.year}
              yearText={t(year.yearText)}
            />
          ))}
        </div>
        <div className={styles.history__arrows}>
          <CircleButton
            name="scroll to previous"
            onClick={() => scrollYear('left')}
            as={'button'}
            styleType="secondary"
            content={<ArrowIcon />}
            theme="light"
          />
          <CircleButton
            name="scroll to next"
            onClick={() => scrollYear('right')}
            as={'button'}
            styleType="secondary"
            content={<ArrowIcon isRight />}
            theme="light"
          />
        </div>
      </div>
    </div>
  );
};
